import {http} from '@kunlun/dependencies';

/**
 * 同步导出接口
 *
 * @export
 * @param {*} model
 * @param {*} validateFunctionName
 * @param params
 * @param exportId
 * @return {*}
 */
export async function exportFile(model, validateFunctionName, params, exportId) {
    let modelName = model.model.split('.')[model.model.split('.').length - 1];
    modelName = modelName.charAt(0).toLowerCase() + modelName.slice(1);
    params.queryData.exportId = exportId;
    let queryData = JSON.stringify(params.queryData, (key, value) => {
        if (value === null || value === undefined || key == '__draftId') {
            return undefined;
        }
        return value;
    })
    queryData = queryData.replaceAll('"','\\"')
    console.log(queryData)
    const query = `{
    ${modelName}Query{
      ${validateFunctionName}(
        queryWrapper: {rsql: "(1==1) and (${params.rsql})", queryData: "${queryData}"}
      ) 
    }
  }`;
    const result = await http.query<any[]>(model.moduleName, query);
    return result.data[modelName + 'Query'][validateFunctionName];
}

/**
 * 同步导出接口
 *
 * @export
 * @param {*} model
 * @param {*} validateFunctionName
 * @param params
 * @param exportId
 * @return {*}
 */
export async function getExportProgress(exportId) {
    const query = `{
    ariesExportProgressQuery{
      queryOne(query: { exportId: ${exportId}}      )
        {   export     total }
    }
  }`;
    const result = await http.query<any[]>("ariesExportProgressQuery", query);
    return result.data['ariesExportProgressQuery']["queryOne"];
}
